import React from 'react';
import { event } from '../data/masterclass';
export function Footer() {
  return <footer className="border-t border-ink-line bg-ink-soft" data-id="element-53" data-mp="3gezdb400vr15">
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-6 px-6 py-12 text-center sm:flex-row sm:justify-between sm:text-left lg:px-10" data-id="element-54" data-mp="3ggk88uq91bzj">
        <div className="flex items-center gap-4" data-id="element-55" data-mp="36ooaxlvzlpwd">
          <img src={event.logoUrl} alt="" aria-hidden="true" className="h-14 w-14 object-contain" data-id="element-56" data-mp="36nd1b5fv1nxc" />
          <div data-id="element-57" data-mp="37o38m5zzh95">
            <p className="font-display text-xl font-semibold uppercase text-white" data-id="element-58" data-mp="387fbm8yvbf9">
              {event.brand}
            </p>
            <p className="text-sm text-white/45" data-id="element-59" data-mp="3lgonkhff80o6">
              {event.title} MasterClass — {event.dateLabel}, {event.timeLabel}
            </p>
          </div>
        </div>
        <p className="text-xs uppercase tracking-overline text-white/30" data-id="element-60" data-mp="29xm24swmjcl7">
          © {new Date().getFullYear()} Meet the Eatmons
        </p>
      </div>
    </footer>;
}